import type { FaireProductEntity } from "../../entity_types/product";

export const p_krbyj8b5np: FaireProductEntity = {
  token: "p_krbyj8b5np",
  type: "product",
  name: "White Sage Smudge Sticks with Palo Santo",
  brandToken: "b_c1fj2fenif",
  brandName: "Picki Nicki",
  imageUrl:
    "https://cdn.faire.com/fastly/96d2cf7152b167e94f8a4f36fb3b30b332f6befbcbf6ccaebbaf85308d2384f0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9202e76b08ac13c245796d52935d1e42bb7052d7797a96ca8ea08c4bc83f1f4d.jpeg",
    "https://cdn.faire.com/fastly/0ecf48825ab42bdda9c5cacda78c8c00de375c82815bab763f9f244067e517ef.jpeg",
    "https://cdn.faire.com/fastly/e6df6879db20c304d819bed057b4f52f5e4d5e5035460a9520d35edf676dc6ad.jpeg",
    "https://cdn.faire.com/fastly/68f9ce010cb6449fc662083e9fbad70b2f877efacde901c4b39b0af9737d085b.png",
  ],
  priceDollars: 4,
  description:
    "White Sage (Salvia Apiana) smudge sticks with Palo San to help purify your space and bring calm and blessings to your life. Each sage smudge stick is hand-picked, dried, and carefully tied using only the highest quality California White Sage. Our fragrant sage burns well and smells fantastic.\n\nOur White Sage is grown on a small farm in Southern California and is sustainably harvested.\n\nOur palo santo is sustainably harvested and eco-friendly. When burned, it gives off warming, nurturing scent with a hint of citrus.\n\nThe Palo Santo is imported from Ecuador and is made from the wood of dried branches or trees that have fallen naturally in the forest.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:10.388Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
